/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ThirdPartySubscription {
    getFixupPrototypeFunction() { return ThirdPartySubscription.fixupPrototype; }

    static newInstance(model: Partial<ThirdPartySubscription>): ThirdPartySubscription {
        let obj = Object.assign(new ThirdPartySubscription(), model);
        ThirdPartySubscription.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ThirdPartySubscription>): ThirdPartySubscription {
        if (!model) return null;
        return ThirdPartySubscription.newInstance(<ThirdPartySubscription> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ThirdPartySubscription) {
        if (!obj) return;

        models.ThirdPartySubscription.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ThirdPartySubscription): boolean {
        Object.setPrototypeOf(obj, ThirdPartySubscription.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.activation_details) {
            models.ActivationDetails.fixupPrototype(this.activation_details);
        }
    }

    /**
     * Provider of subscription
     */
    provider: string;

    /**
     * Type of subscription
     */
    type: models.ThirdPartySubscriptionType;

    /**
     * Subscription Name
     */
    subscription_name: string;

    /**
     * Subscription ID
     */
    subscription_id: string;

    /**
     * Plan ID
     */
    plan_id: string;

    /**
     * Offer ID
     */
    offer_id: string;

    /**
     * Purchaser Email Id
     */
    purchaser_email: string;

    /**
     * Activation Details
     */
    activation_details: models.ActivationDetails;

}
